import Marionette from "backbone.marionette";
import Radio from "backbone.radio";
// import Filters from "./filters";
import FilterButtons from "../../../mixins/datatable/buttons/filter";
import Actions from "./actions";
import templates from "../../../utils/templates";

import "../../../../../sass/view-header.scss";

const channel = Radio.channel("global");

const DEFAULTS = {
  className: "flex",
  template: templates.find("view_header", "actions_placeholder_group"),
  regions: {
    filters: ".filters",
    actions: ".actions",
  },
};

class ViewHeaderActions extends Marionette.LayoutView {
  constructor(options = {}) {
    _.defaults(options, DEFAULTS);
    super(options);
  }

  initialize() {
    this.listenTo(channel, "view-header:filters", this._onFilters);
    this.listenTo(channel, "view-header:actions", this._onActions);
  }

  _onFilters(config) {
    this.filters.show(new FilterButtons(config));
  }

  _onActions(config) {
    this.actions.show(new Actions(config));
  }
}

export { ViewHeaderActions as default };
